var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ActionCart', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "receive-quantity-from-api": ""
    },
    on: {
      "success": function ($event) {
        return _vm.emit('update', _vm.product.id);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$product$gift;

        var remove = _ref.remove,
            decreaseAmount = _ref.decreaseAmount,
            increaseAmount = _ref.increaseAmount,
            active = _ref.active,
            quantity = _ref.quantity,
            loading = _ref.loading;
        return [_c('div', {
          staticClass: "cart-el",
          class: {
            'cart-el_not-available': _vm.isUnavailable
          },
          attrs: {
            "data-e2e-active-product": ("" + (_vm.product.isActive))
          }
        }, [_c('div', {
          staticClass: "cart-el__content"
        }, [_c('div', {
          staticClass: "cart-el__checkbox"
        }, [_c('Checkbox', {
          attrs: {
            "checked": _vm.product.isActive,
            "disabled": _vm.isUnavailable
          },
          on: {
            "change": function ($event) {
              return _vm.emit('check', $event);
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "cart-el__left"
        }, [_c('div', {
          staticClass: "cart-el__photo-wrapper"
        }, [_c('div', {
          staticClass: "cart-el__bonus"
        }, [_vm.product.price && _vm.product.price.bonus ? _c('TSBonusCount', {
          attrs: {
            "count": _vm.product.price.bonus
          }
        }) : _vm._e(), _vm._v(" "), !_vm.product.availableBonusPay && _vm.isUser ? _c('img', {
          attrs: {
            "src": require("@/assets/images/svg/bonusesNotAvailable.svg"),
            "alt": "Оплата бонусами недоступна"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('nuxt-link', {
          staticStyle: {
            "height": "inherit"
          },
          attrs: {
            "to": _vm.product.path
          }
        }, [_c('LazyImg', {
          staticClass: "cart-el__photo",
          attrs: {
            "src": _vm.product.thumbnail.x1,
            "srcset": _vm.product.thumbnail.x2
          }
        })], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "cart-el__title"
        }, [_c('div', {
          staticClass: "cart-el__price cart-el__price_mobile"
        }, [_vm.product.price ? _c('TSPrice', {
          staticClass: "mb-8",
          attrs: {
            "price": _vm.cartProductPrice,
            "type": "cart"
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.product.sale.length ? _c('SaleMarkerList', {
          staticClass: "cart-el__marker",
          attrs: {
            "list": _vm.product.sale,
            "type": "list"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "cart-el__crop"
        }, [_c('nuxt-link', {
          staticClass: "link link_wu",
          attrs: {
            "to": _vm.product.path
          }
        }, [_vm._v("\n              " + _vm._s(_vm.product.name) + "\n            ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "cart-el__tools p"
        }, [_c('div', {
          staticClass: "cart-el__tool cart-el__tool_favorite"
        }, [_c('ActionFavorite', {
          attrs: {
            "id": _vm.product.id,
            "product": _vm.product,
            "list-name": "Корзина"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var addFavorite = _ref2.add,
                  removeFavorite = _ref2.remove,
                  activeFavorite = _ref2.active,
                  loading = _ref2.loading;
              return [_c('UserTool', {
                attrs: {
                  "type": "favorite",
                  "active": activeFavorite,
                  "loading": loading
                },
                on: {
                  "add": addFavorite,
                  "remove": removeFavorite
                }
              })];
            }
          }], null, true)
        })], 1), _vm._v(" "), active ? _c('div', {
          staticClass: "cart-el__count cart-el__count_mobile"
        }, [!_vm.isUnavailable ? _c('TSCounter', {
          attrs: {
            "quantity": quantity,
            "max": 999,
            "loading": loading
          },
          on: {
            "decrease": function ($event) {
              return decreaseAmount({
                id: _vm.product.id,
                quantity: $event
              });
            },
            "increase": function ($event) {
              return increaseAmount({
                id: _vm.product.id,
                quantity: $event
              });
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "cart-el__unavailable-btn cart-el__unavailable-btn_mobile"
        }, [_c('span', [_vm._v("Распродан")])]), _vm._v(" "), _c('div', {
          staticClass: "cart-el__tool cart-el__tool_delete"
        }, [_c('span', {
          staticClass: "link-icon link-icon_wu fz-14",
          on: {
            "click": remove
          }
        }, [_c('div', {
          staticClass: "link-icon__icon-bin"
        }), _vm._v(" "), _c('div', {
          staticClass: "link-icon__text cart-el__tool-delete"
        }, [_vm._v("Удалить")])])])])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "cart-el__unavailable-btn cart-el__unavailable-btn_desktop"
        }, [_c('span', [_vm._v("Распродан")])]), _vm._v(" "), _c('div', {
          staticClass: "cart-el__right"
        }, [_c('div', {
          staticClass: "cart-el__count cart-el__count_desktop"
        }, [active ? _c('TSCounter', {
          attrs: {
            "quantity": _vm.product.quantity,
            "max": 999,
            "loading": loading
          },
          on: {
            "decrease": function ($event) {
              return decreaseAmount({
                id: _vm.product.id,
                quantity: $event
              });
            },
            "increase": function ($event) {
              return increaseAmount({
                id: _vm.product.id,
                quantity: $event
              });
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "cart-el__price cart-el__price_desktop"
        }, [_c('div', {
          staticClass: "cart-el__price-top"
        }, [_vm.product.price ? _c('TSPrice', {
          staticClass: "mb-8",
          attrs: {
            "price": _vm.cartProductPrice,
            "bonus-pay": _vm.product.availableBonusPay,
            "type": "cart"
          }
        }) : _vm._e(), _vm._v(" "), !_vm.product.availableBonusPay && _vm.isUser ? _c('img', {
          attrs: {
            "src": require("@/assets/images/svg/bonusesNotAvailable.svg"),
            "alt": "Оплата бонусами недоступна"
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.product.price && _vm.product.price.bonus ? _c('TSBonusCount', {
          attrs: {
            "count": _vm.product.price.bonus
          }
        }) : _vm._e()], 1)])]), _vm._v(" "), (_vm$product$gift = _vm.product.gift) !== null && _vm$product$gift !== void 0 && _vm$product$gift.length ? _c('div', {
          staticClass: "cart-el__gifts"
        }, [_c('GiftItem', {
          attrs: {
            "gift": _vm.product.gift[0],
            "count": _vm.product.gift.length
          }
        })], 1) : _vm._e()])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }